<template>
    <d2-container :filename="filename">
        <template slot="header">
            <el-badge :value="data.length" class="item">
                摄影图片管理
            </el-badge>
        </template>
        <el-table
                v-loading="loading"
                :data="data"
                stripe
                style="width: 100%">
            <el-table-column
                    prop="icon"
                    label=""
                    width="35">
                <template slot-scope="scope">
                    <d2-icon name="file-image-o"></d2-icon>
                </template>
            </el-table-column>
            <el-table-column
                    prop="file"
                    label="文件名">
            </el-table-column>
            <el-table-column
                    prop="use"
                    label="使用">
                <template slot-scope="scope">
                    <span v-if="scope.row.use" style="color: green">存在</span>
                    <span v-else style="color: red">不存在</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="do"
                    label="操作">
                <template slot-scope="scope">
                    <el-button type="primary" @click="view(scope.row.file)">查看</el-button>
                    <el-button type="danger" @click.native.prevent="deleteRow(scope.$index, data)" :disabled="scope.row.use">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <template slot="footer">
            www.heanny.cn
        </template>
        <el-dialog

                :visible.sync="dialogVisible"
                width="30%" style="text-align: center">
            <img :src="'//cdn.heanny.cn/Photo/'+imgurl" alt="" style="max-width:100%;margin: 0 auto">
            <span slot="footer" class="dialog-footer" v-text="imgurl"> </span>
        </el-dialog>
    </d2-container>
</template>

<script>
    export default {
        data() {
            return {
                filename: __filename,
                data: [],
                dialogVisible: false,
                loading: false,
                imgurl: ''
            }
        },
        methods: {
            getData() {
                this.loading = true
                this.$request({
                    url: "getImgFile.do",
                    data: {
                        path: 'Photo',
                        // action: 'getUserImgs',
                    }
                }).then(res => {
                    const list = []
                    const sqlList = res.sql
                    res.file.map(v => {
                        if (v.file !== '' || v.file != null || v.file !== 'null') {
                            if (sqlList.indexOf(v.file)===-1) {
                                list.push({file: v.file, use: false})
                            } else {
                                list.push({file: v.file, use: true })
                            }
                        }
                    })
                    this.loading = false
                    this.data = list
                }).catch((error) => {
                    this.msg = error
                    this.loading = false
                })
            },
            view(file) {
                this.imgurl = file
                this.dialogVisible = true
            },
            deleteRow(index, rows) {
                this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$request({
                        url: 'imgFile.php',
                        method: 'post',
                        data: {action: 'delFile', file: rows[index].file, type: 'Photo'}
                    }).then(res => {
                        rows.splice(index, 1);
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });

            },

        },
        created: function () {
            this.getData()
        }
    }
</script>
<style>
    .time {
        font-size: 13px;
        color: #999;
    }

    .bottom {
        margin-top: 13px;
        line-height: 12px;
    }

    .button {
        padding: 0;
        float: right;
    }

    .image {
        width: 100%;
        display: block;
    }

    .clearfix:before,
    .clearfix:after {
        display: table;
        content: "";
    }

    .clearfix:after {
        clear: both
    }
</style>
